import { PropsWithChildren } from 'react';
import { useBackground } from './useBackground';

import type { StackProps } from '@cast/design-system';
import { Stack } from '@cast/design-system';

export const OrganizationContainer = ({
  children,
  ...props
}: PropsWithChildren<StackProps>) => {
  useBackground();

  return (
    <Stack flex={1} height="100%" {...props}>
      {children}
    </Stack>
  );
};
